import IconCatch from '@/components/icons/icon-catch/icon-catch';
import { MediaBlock } from '@cmpsr/blocks';
import { Box, Text } from '@cmpsr/components';
import React from 'react';
import { useSearchParams } from 'react-router-dom';
import MarkdownTextTailwind from '@/components/markdown/markdown-text-tailwind';
import HeaderBackground from '@/components/ui/header-background/header-background';

type HeroAccountProps = {
  username?: string;
};

function HeroAccount({ username }: HeroAccountProps) {
  const [searchParams] = useSearchParams();
  const isHealthDataTab = searchParams.get('tab') === 'risk';

  return (
    <Box position="relative" overflow="hidden" backgroundColor="#0a0a0a" mb={{ base: 'spacer-2', md: 'spacer-4' }}>
      <HeaderBackground blur={30} />
      <MediaBlock
        variant="horizontal"
        px={{ base: 'spacer-4', md: 'spacer-8', lg: 'spacer-16', xl: 'spacer-24', xxl: 'spacer-32' }}
        py={{ base: 'spacer-5', md: 'spacer-7', lg: 'spacer-8', xl: 'spacer-9' }}
        alignItems="center"
        maxWidth="1440px"
        marginX="auto"
        position="relative"
        zIndex={1}
      >
        <Text
          variant={{ base: 'text-header-XL', md: 'text-header-2XL', lg: 'text-header-2XL' }}
          color="text-light"
          whiteSpace="nowrap"
          overflow="hidden"
          textOverflow="ellipsis"
        >
          {isHealthDataTab ? (
            <MarkdownTextTailwind
              className="text-[var(--font-size-desktop-header-2xl)] text-white"
              components={{
                em: ({ children }) => (
                  <span style={{ fontFamily: 'Libre Baskerville, serif', fontStyle: 'normal' }}>{children}</span>
                ),
              }}
            >
              Health *Data*
            </MarkdownTextTailwind>
          ) : username ? (
            <>
              Hi {username}!
            </>
          ) : (
            <Text
              as="span"
              textStyle={{ base: 'text-header-xl-v', md: 'text-header-2xl-v', lg: 'text-header-2xl-v' }}
              color={{ base: 'text-light', md: 'text-light', lg: 'text-light' }}
            >
              Welcome!
            </Text>
          )}
        </Text>
      </MediaBlock>
    </Box>
  );
}

export default React.memo(HeroAccount);
